import { useState } from 'react';

import { loadScript } from '@crehana/utils';

import { URLS } from 'Jsx/CheckoutV4/common/constants';

import { MercadoPago } from '../types/MercadoPago';

export const useMercadoPago = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [mercadoPago, setMercadoPago] = useState<MercadoPago | undefined>();

  const loadMercadoPagoScript = async () => {
    const isSDKLoaded = window.MercadoPago !== undefined;

    if (!isSDKLoaded) {
      setIsLoading(true);
      const scriptResponse = await loadScript({ src: URLS.mercadopago });

      setIsLoading(false);
      if (!scriptResponse)
        throw new Error(`Mercadopago library failed to load`);
    }
  };

  const loadMercadoPago = (): MercadoPago => {
    if (mercadoPago) return mercadoPago;
    loadMercadoPagoScript();
    const newMercadoPago = new window.MercadoPago(
      window.MERCADOPAGO_API_MX_PUBLIC_KEY,
    );

    setMercadoPago(newMercadoPago);
    return newMercadoPago;
  };

  return { isLoading, loadMercadoPago };
};
